import ajax from "../helpers/ajax";
import StoreContainer from "../stores/StoreContainer";
import { EcommerceData } from "../types";

class EcommerceService {
  static async postEcommerceData(
    siteId: number,
    visitorId: string,
    data: EcommerceData,
    engagementId: string
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/Ecommerce/Data`,
      method: "post",
      data: { visitorId, data, engagementId }
    });
  }

  static async postSale(
    siteId: number,
    visitorId: string,
    id: string,
    url: string
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/Ecommerce/Sale`,
      method: "post",
      data: { visitorId, id, url }
    });
  }

  static async postCampaignId(
    siteId: number,
    visitorId: string,
    campaignId: string,
    pageUrl: string
  ) {
    return await ajax({
      url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/Ecommerce/Campaign`,
      method: "post",
      data: { visitorId, campaignId, pageUrl }
    });
  }

  static async postExternalId(
    siteId: number,
    visitorId: string,
    externalId: string,
    url: string
  ) {
    return await ajax({
      url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/Ecommerce/ExternalId`,
      method: "post",
      data: { visitorId, externalId, url }
    });
  }
}

export default EcommerceService;
